export enum AuthorizeAthleteStepFlow {
  CHECK_EMAIL = 1,
  CREATE_ACCOUNT = 2,
  VERIFY_ACCOUNT = 3,
  LOGIN = 4,
  AUTHORIZATION = 5,
  SUCCESS = 6,
  ALREADY_EXISTS = 7,
}
